exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.indent-contact-body[data-v-8ff8a458] {\n  white-space: pre-line;\n  word-break: break-all;\n}\n", ""]);

// exports
